import GroupEditor from './columnsEditor';

export default GroupEditor;
